module.exports = __webpack_public_path__ + "static/media/4playerRoomsPlayed_5000_10000.4f9dce35.png";